import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';
import { SymbolSyntheticTranslator } from '../symbolSynthetic.translator';

type IDependencies = IClientApiDependencySegment;

export const createSymbolSyntheticEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.create.started),
  mergeMap((params) => {
    const { reject } = params;

    return dependencies.api.createSyntheticSymbol(SymbolSyntheticTranslator.toApi(params)).pipe(
      mergeMap((response) => {
        return [
          SymbolSyntheticAction.create.done({ params, result: { symbolId: response.id } }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SymbolSyntheticAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
